<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10JTyFg/tc-custom/9781460303092.jpg?1704268792337" alt="This image is the cover for the book Fortune"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fortune
      </h1>
      <p class="bookDescription body article font2">
        <b>In this “high adventure of love’s triumph over twisted obsession” from a <i>New York Times </i>bestseller, a woman confronts her abusive past (<i>Publishers Weekly</i>).</b><br/><br/>A mother’s ultimate sacrifice . . . A brother’s dark obsession . . . And one woman’s desperate fight for survival . . .<br/><br/>Something dark and dangerous had long shadowed Skye Dearborn’s life. She had seen the fear of it in her mother’s eyes. It was there, locked in her memories of blood spilling across a gleaming floor. In the sound of her own screams. And in the terror she’d felt the night her mother disappeared.<br/><br/>Then fortune smiled on Skye. With help she was able to put the horror behind her and look to the future.<br/><br/>But now that same fortune is leading her into the arms of danger—and back into the nightmare of her past. For the evil that has haunted her dreams has a human form—a man obsessed with Skye since her birth. A man who alone knows who Skye Dearborn really is.<br/><br/>And now that he has found her, he will do anything to keep her.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Erica Spindler
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?388968ad